import { Disclosure, DisclosureGroup, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { FaqItem } from "../types";

type FaqSectionProps = {
  id: string;
  title: string;
  items: FaqItem[];
  /** ISO (AAAA-MM-DD); o mesmo valor vai como `dateModified` no `FAQPage`. */
  updatedAt: string;
};

const formatDate = (iso: string) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

/**
 * FAQ com a resposta sempre no HTML (`<details>` nativo), mesmo fechada: o
 * Google exige a resposta visível e os LLMs leem o HTML do prerender.
 */
export const FaqSection = ({
  id,
  title,
  items,
  updatedAt,
}: FaqSectionProps) => (
  <PageSection labelledBy={`${id}-title`} className="flex flex-col gap-6">
    <div className="flex flex-col gap-2">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      <Text size="small" tone="subtle">
        Atualizado em <time dateTime={updatedAt}>{formatDate(updatedAt)}</time>
      </Text>
    </div>
    <DisclosureGroup>
      {items.map(item => (
        <Disclosure
          key={item.question}
          summary={item.question}
          headingLevel={3}
        >
          <Text tone="muted">{item.answer}</Text>
        </Disclosure>
      ))}
    </DisclosureGroup>
  </PageSection>
);
